if (!customElements.get("quick-view-modal")) {
    customElements.define(
      "quick-view-modal",
      class QuickViewModal extends ModalDialog {
        constructor() {
          super();
          this.modalContent = this.querySelector("#QuickViewModal");

          this.addEventListener("product-info:loaded", ({ target }) => {
            target.addPreProcessCallback(this.preprocessHTML.bind(this));
          });
        }

        // # DIGILOOP - prevent product click
        handleButtonClick(event) {
          event.preventDefault();
          let target = event.target;
          this.handleContent(target?.href);
          
        }

        // # DIGILOOP - hide video in quickview
        handleHideVideo(event) {
          event?.target?.closest('media-gallery')?.querySelector('.swiper-main')?.querySelector('.video-display-for-quickview').classList.remove('opened');
        }

        // # DIGILOOP - hide model in quickview
        handleHideModel(event) {
          event?.target?.closest('media-gallery')?.querySelector('.swiper-main')?.querySelector('.model-display-for-quickview').classList.remove('opened');
        }

        // # DIGILOOP - show video in quickview
        handleDisplayVideo(event) {
          this.handleHideModel(event);
          event?.target?.closest('media-gallery')?.querySelector('.video-display-for-quickview').classList.add('opened');  
        }

        // # DIGILOOP - show model in quickview
        handleDisplayModel(event) {
          this.handleHideVideo(event);
          event?.target?.closest('media-gallery')?.querySelector('.model-display-for-quickview').classList.add('opened');  
        }

        // # DIGILOOP - added global function to fill content
        handleContent(url, opener) {
          fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
              const responseHTML = new DOMParser().parseFromString(
                responseText,
                "text/html"
              );
              const productElement = responseHTML.querySelector("product-info");

              this.preprocessHTML(productElement);
              HTMLUpdateUtility.setInnerHTML(
                this.modalContent,
                productElement.outerHTML
              );

              // Ensure CompareColor component is defined when content is injected
              if (typeof window.compareColor === 'undefined' && !customElements.get('compare-color')) {
                try { window.compareColor(); } catch (e) { /* no-op */ }
              }

              if (window.Shopify && Shopify.PaymentButton)
                Shopify.PaymentButton.init();
              if (window.ProductModel) window.ProductModel.loadShopifyXR();

              super.show(opener);

              // # DIGILOOP - added event listener to prevent product page open
              this.modalContent.querySelector('variant-selects').addEventListener("click", this.handleButtonClick.bind(this));

              // # DIGILOOP - added event listener display youtube videos
              /*this.modalContent.querySelectorAll('.video-dialog-button').forEach(button => { button.addEventListener("click", this.handleDisplayVideo.bind(this)) }); */
              this.modalContent.querySelector('.video-dialog-button')?.addEventListener("click", this.handleDisplayVideo.bind(this));
              this.modalContent.querySelectorAll('.swiper-controls__thumbnails-container, .video-display-for-quickview .quickview-display__close-button').forEach(button => {button.addEventListener('click', this.handleHideVideo.bind(this))});
              //this.modalContent.querySelector('.video-display-for-quickview .quickview-display__close-button').addEventListener("click", this.handleHideVideo.bind(this));

              this.modalContent.querySelector('.model-dialog-button')?.addEventListener("click", this.handleDisplayModel.bind(this));
              this.modalContent.querySelectorAll('.swiper-controls__thumbnails-container, .model-display-for-quickview .quickview-display__close-button').forEach(button => {button.addEventListener('click', this.handleHideModel.bind(this))});              

            })
            .finally(() => {
              opener?.removeAttribute("aria-disabled");
              opener?.classList.remove("loading");
              opener?.querySelector(".loading__spinner").classList.add("hidden");

            });
        }

        hide(preventFocus = false) {
          const cartNotification = document.querySelector("cart-drawer");
          if (cartNotification)
            cartNotification.setActiveElement(this.openedBy);
          setTimeout(() => (this.modalContent.innerHTML = ""), 500);

          if (preventFocus) this.openedBy = null;
          super.hide();
        }

        show(opener) {
 
          opener.setAttribute("aria-disabled", true);
          opener.classList.add("loading");
          opener.querySelector(".loading__spinner").classList.remove("hidden");

          // # DIGILOOP - replaced to the new function
          this.handleContent(opener.getAttribute("data-product-url").split("?")[0], opener)

        
        }

        preprocessHTML(productElement) {
          productElement.classList.forEach((classApplied) => {
            if (
              classApplied.startsWith("color-") ||
              classApplied === "gradient"
            )
              this.modalContent.classList.add(classApplied);
          });
          this.preventDuplicatedIDs(productElement);
          this.removeDOMElements(productElement);
          this.removeGalleryListSemantic(productElement);
          this.preventVariantURLSwitching(productElement);
        }

        preventVariantURLSwitching(productElement) {
          productElement.setAttribute("data-update-url", "false");
        }

        removeDOMElements(productElement) {
          const pickupAvailability = productElement.querySelector(
            "pickup-availability"
          );
          if (pickupAvailability) pickupAvailability.remove();

          const shareButton = productElement.querySelector("share-button");
          if (shareButton) shareButton.remove();

          const productModal = productElement.querySelector("product-modal");
          if (productModal) productModal.remove();

          const modalDialog = productElement.querySelectorAll("modal-dialog");
          if (modalDialog) modalDialog.forEach((modal) => modal.remove());

          // # DIGILOOP - display yt video icon
          const sideDrawerOpener = productElement.querySelectorAll(
            "side-drawer-opener:not(.agree-condition-popup-modal__opener--keep):not(.video-dialog-button,.model-dialog-button)"
          );
          if (sideDrawerOpener)
            sideDrawerOpener.forEach((button) => button.remove());

          const sideDrawer = productElement.querySelectorAll(
            "side-drawer:not(.agree-condition-popup-modal__drawer--keep)"
          );
          if (sideDrawer) sideDrawer.forEach((drawer) => drawer.remove());
        }

        preventDuplicatedIDs(productElement) {
          const sectionId = productElement.dataset.section;

          const oldId = sectionId;
          const newId = `quickview-${sectionId}`;

          productElement.innerHTML = productElement.innerHTML.replaceAll(
            oldId,
            newId
          );
          Array.from(productElement.attributes).forEach((attribute) => {
            if (attribute.value.includes(oldId)) {
              productElement.setAttribute(
                attribute.name,
                attribute.value.replace(oldId, newId)
              );
            }
          });

          productElement.dataset.originalSection = sectionId;
        }

        removeGalleryListSemantic(productElement) {
          const galleryList = productElement.querySelector(
            '[id^="Slider-Gallery"]'
          );
          if (!galleryList) return;

          galleryList.setAttribute("role", "presentation");
          galleryList
            .querySelectorAll('[id^="Slide-"]')
            .forEach((li) => li.setAttribute("role", "presentation"));
        }
      }
    );
}
